import React from 'react';
import ModelOption from './ModelOption';

const ModelMenu = (props) => {
        return(
            <div>
                <select name={props.name} className="form-control" onChange={props.setModel}>
                    <option value='model'>Model...</option>
                    {Object.keys(props.modelMenu).map(key => <ModelOption
                        key={key}
                        value={key}
                    />)}
                </select>
            </div>
        );
}

export default ModelMenu;